import { LOGIN_SUCCESS, LOGOUT_SUCCESS, LOGIN_FAILURE, LOGOUT_FAILURE, NOT_LOGGED_IN } from 'src/constants/ActionTypes';
import { IStateAuth } from 'src/entity/StateEntity';

const initialState: IStateAuth = {
  isLogin: false,
  accessToken: undefined,
  menuItem: {
    menus: [],
    others: [],
  },
  type: LOGOUT_SUCCESS,
};

export const authState = (state: IStateAuth = initialState, action: IStateAuth): IStateAuth => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        type: action.type,
        isLogin: true,
        accessToken: action.accessToken,
        menuItem: action.menuItem,
      });
    case LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        type: action.type,
        isLogin: false,
        accessToken: action.accessToken,
        menuItem: action.menuItem,
      });
    case LOGIN_FAILURE:
      return Object.assign({}, state, {
        type: action.type,
        isLogin: false,
        accessToken: action.accessToken,
        menuItem: action.menuItem,
      });
    case LOGOUT_FAILURE:
      return Object.assign({}, state, {
        type: action.type,
        isLogin: true,
        accessToken: action.accessToken,
        menuItem: action.menuItem,
      });
    case NOT_LOGGED_IN:
      return Object.assign({}, state, {
        type: action.type,
        isLogin: false,
        accessToken: undefined,
        menuItem: [],
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/authState.ts